import { render, staticRenderFns } from "./2_doctorSelection.vue?vue&type=template&id=42b4be0b&scoped=true&"
import script from "./2_doctorSelection.vue?vue&type=script&lang=js&"
export * from "./2_doctorSelection.vue?vue&type=script&lang=js&"
import style0 from "./2_doctorSelection.vue?vue&type=style&index=0&id=42b4be0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b4be0b",
  null
  
)

export default component.exports